import React from 'react';
import PropTypes from 'prop-types';
import InputText from '../../Common/InputText';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import TextArea from '../../Common/TextArea';

export const UserProfileForm = (props) => {
    const onChange = (e) => {
        props.onFormChange(e.target.name, e.target.value);
    }

    const onMultiSelectChange = (value, name) => {
        props.onFormChange(name, value.toString());
    }

    const onManagementCompanyChange = (value, name) => {
        props.onManagementCompanyChange(name, value.toString());
    }

    const onSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        props.onContinue();
    }

    const valid = props.isFormValid ? "" : "was-validated";
    const className = "user-profile-set-form " + valid;

    return (
        <form onSubmit={onSubmit} className={className} noValidate>
            <div>The administrator for this subscription needs to know more about your role and the locations you need access to.</div>
            <br />
            {
                props.userRequest.isSubscriptionSSOEnabled
                ?
                <InputText name="employeeId" label="Employee ID" placeholder="Employee ID" type="text" value={props.userRequest.employeeId} onChange={onChange} isRequired={true} errorMessage="Employee ID is required" />
                :
                <InputText name="employeeId" label="Employee ID" placeholder="Employee ID" type="text" value={props.userRequest.employeeId} onChange={onChange} />
            }

            <MultiSelectBox name="managementCompanyId" label="Management Company" idField="id" valueField="name"
                options={props.managementCompanies}
                onChange={onManagementCompanyChange}
                defaultValue="Select a Management Company"
                selectedValues={props.userRequest.managementCompanyId.toString()}
                isRequired={true}
                errorMessage="Management Company is required"
                isMulti={false}
            />

            <MultiSelectBox name="communityIds" label="Communities" idField="id" valueField="name"
                options={props.communities}
                selectedValues={props.userRequest.communityIds.toString()}
                onChange={onMultiSelectChange}
                isRequired={true}
                errorMessage="At least one Community must be selected"
                isMulti={true}
            />

            <MultiSelectBox name="departmentIds" label="Favorite Departments" idField="id" valueField="name"
                options={props.departments}
                selectedValues={props.userRequest.departmentIds.toString()}
                onChange={onMultiSelectChange}
                isMulti={true}
            />

            <MultiSelectBox name="locationId" label="Requested Location" idField="id" valueField="name"
                options={props.locations}
                onChange={onMultiSelectChange}
                defaultValue="Select a Location"
                selectedValues={props.userRequest.locationId.toString()}
                isRequired={true}
                errorMessage="Requested Location is required"
                isMulti={false}
            />

            <TextArea rows={2} name="additionalNotes" placeholder="Additional Notes" label="Additional Notes" value={props.userRequest.additionalNotes} onChange={onChange} />

        </form>
    );
}

UserProfileForm.propTypes = {
    userRequest: PropTypes.object.isRequired,
    onContinue: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onFormChange: PropTypes.func.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    userAccessRequestActions: PropTypes.object.isRequired,
    onManagementCompanyChange: PropTypes.func.isRequired,
    communities: PropTypes.array.isRequired,
    countries: PropTypes.array.isRequired,
    departments: PropTypes.array.isRequired,
    managementCompanies: PropTypes.array.isRequired,
    locations: PropTypes.array.isRequired
};

export default UserProfileForm;
